import { render, staticRenderFns } from "./MagicBlock.vue?vue&type=template&id=53cd40d6&scoped=true"
import script from "./MagicBlock.vue?vue&type=script&lang=ts"
export * from "./MagicBlock.vue?vue&type=script&lang=ts"
import style0 from "./MagicBlock.vue?vue&type=style&index=0&id=53cd40d6&prod&lang=scss&scoped=true"
import style1 from "./MagicBlock.vue?vue&type=style&index=1&id=53cd40d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cd40d6",
  null
  
)

export default component.exports